import Service from "@/helpers/py-service";

const state = {
  loading: false,
  meta: {},
  list: [],
};

const mutations = {
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  
  SET_LIST(state, payload) {
    state.list = payload;
  },

  UPDATE_LIST(state, payload) {
    const item = state.list.find((item) => item.id === payload.id);
    Object.assign(item, payload);
  },

  DELETE_LIST(state, payload) {
    state.list.splice(
      state.list.map((o) => o.id).indexOf(payload.id),
      1
    );
  },
  
};

const actions = {

  list: (store, params) => {
    store.state.loading = true;
    return Service
      .get("roles-and-permissions/tiers", params)
      .then((data) => {
        store.commit("SET_META", data.body);
        store.commit("SET_LIST", data.body.data);
        return data.body.data;
      })
      .finally(() => (store.state.loading = false));
  },
  add: (store, { payload, filter }) => {
    store.state.loading = true;
    return Service
      .post("roles-and-permissions/tiers", payload)
      .then(() => {
        store.dispatch("list", filter);
      })
      .finally(() => (store.state.loading = false));
  },
  update: (store, params) => {
    store.state.loading = true;
    return Service
      .put(`roles-and-permissions/tiers/${params.id}`, params)
      .then((data) => {
        store.commit("UPDATE_LIST", data.body);
        return data?.body;
      })
      .finally(() => (store.state.loading = false));
  },
  destroy: (store, params) => {
    return Service.destroy(`roles-and-permissions/tiers/${params.id}`).then(data=>{
      store.commit("DELETE_LIST", data);
      return data
    })
  },

  assign: (store, params) => {
    return Service.post(`roles-and-permissions/product-tiers`,params).then(data=>{
      store.dispatch("list");
      return data
    })
  },
  
  unassign: (store, params) => {
    return Service.destroy(`roles-and-permissions/tiers/product-tiers/${params.id}`,params).then(data=>{
      store.dispatch("list");
      return data
    })
  },

  
};

const getters = {
  
  getLoading(state) {
    return state.loading;
  },

  getMeta(state) {
    return state.meta;
  },
  getList(state) {
    return state.list;
  },
  
};

const productTiers = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default productTiers;
